module.exports = "::ng-deep .mat-select-arrow {\n  border-color: white !important;\n}\n\nmat-icon {\n  color: #888;\n}\n\n.width-100 {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 100%;\n          flex: 1 100%;\n}\n\n.loader {\n  color: rgb(66, 133, 244);\n}\n\n.flexbox-container {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-align: center;\n  -webkit-box-align: center;\n  align-items: center;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/book/dewey-selector/dewey-selector.component.css
// module id = ./src/app/components/book/dewey-selector/dewey-selector.component.css
// module chunks = main